import React from "react";
import Icon from "../icon/Icon";
import styles from "./Toaster.module.css";
import toasterConfig from "../../config/toasterConfig";
import {withTranslation} from 'react-i18next';
import ToasterSingleton from "../../singleton/ToasterSingleton";


class Toaster extends React.Component {

    timer = null;

    constructor(props) {
        super(props);
        this.setText = this.setText.bind(this);
        this.state = {

            show: true,
            text: this.props.text,
            type: this.props.type,
            classCustom: this.props.type + "Custom",
            toaster: this.props.toaster,
            timeout: toasterConfig.timeout.standard_closing,
            identificativo: this.props.identificativo ? this.props.identificativo : null
        };

        if (this.props.timeout)
            this.state.timeout = this.props.timeout;

    }

    getNameIcon(type) {

        if (type) {
            return toasterConfig.icons[type]
        } else
            return ""
    }

    componentDidMount() {
        this.timer = setTimeout(() => {
                ToasterSingleton.instance().onCloseToaster(this.props.id)
            },
            this.state.timeout);
    }

    componentWillUnmount() {
        clearTimeout(this.timer);
    }

    setText(){
        let boxesText = []
        let {t} = this.props;

        if(this.props && !this.props.textList){
            boxesText.push(
                t(this.state.text)
            )
        }
        else{
            let boxText = []
            this.state.text.forEach( text => {
                boxText.push(
                   <li>{text}</li>
                )
            })
            boxesText.push(
                <div>
                    <ul>
                        {boxText}
                    </ul>
                </div>

            )
        }
        return boxesText;
    }


    render() {
        const {t} = this.props;

        var title = this.props.title ? t("Toasters.Titles." + this.props.title) : t("Toasters.Titles." + this.state.type);


        return (
            <div
                className={["col", this.props.classes, styles.toaster].join(" ")}
                style={!this.state.show ? {
                    display: "none !important",
                    visibility: "hidden !important",
                    position: "absolute", left: "-999999px"
                } : {}}
            >
                <div
                    className={["col-10 ", styles.containerToaster, styles[this.state.type]]
                        .join(" ")
                        .concat(" shadow")}
                    role="alert"
                >
                    <div className={styles.iconTostaer}>
                        <Icon
                            id={this.getNameIcon(this.state.type)}
                            classes={
                                this.state.type === "successo" ? "icon-black" : "icon-white"
                            }
                            style={{width: "38px", height: "38px"}}
                        />
                    </div>

                    <div className={styles.testoToaster}>
                        <span style={{fontSize: "20px", fontWeight: "bold"}}>
                            {title}
                        </span>
                        <br/>
                        {this.setText()}
                    </div>

                    <button
                        onClick={() => {
                            ToasterSingleton.instance().onCloseToaster(this.props.id)
                        }}
                        type="button"
                        className={[
                            styles.buttonToaster,
                            styles[this.state.classCustom]
                        ].join(" ")}
                        data-dismiss="alert"
                        aria-label="Close"
                    >
                        <Icon
                            classes={
                                this.state.type === "successo" ? "icon-black" : "icon-white"
                            }
                            id="it-close"
                        ></Icon>
                    </button>
                    <br/>
                    {this.state.identificativo ? <span style={{
                        right: "0",
                        position: "absolute",
                        bottom: "0",
                        marginRight: "5px",
                        color: "#E8E8E8"
                    }}>{this.state.identificativo}</span> : null}
                </div>
            </div>
        );
    }
}

export default withTranslation('common')(Toaster)
